import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { ixIntegrationApi } from "./api";
import { queryClient } from "@shared/api/queries/queryClient";

// Add your feature-specific hooks here
export const usePSPConfig = (remoteUtilityId: string) =>
  useSmartQuery(
    QueryKeyFactory.module.ix.payments.pspConfig(),
    () =>
      ixIntegrationApi.getPSPConfigurationDetails(remoteUtilityId),
    {
      enabled: !!remoteUtilityId,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 0,
    }
  );

  export const useChoices = (choice: string) =>
  useSmartQuery(
    QueryKeyFactory.module.ix.payments.choices(choice),
    () =>
      ixIntegrationApi.getChoices(choice),
    {
      enabled: !!choice,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 0,
    }
  );

 export const useUpdatePSPConfig = (pspUtilityId: number | null) =>
   useSmartMutation((payload: any) =>
     ixIntegrationApi.updatePSPConfigurationDetails(pspUtilityId, payload)
   );

export const useAddPaymentConfig = (payload?: any) => {
  return useSmartMutation(ixIntegrationApi.addPaymentConfig, {
    ...payload,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["ix", "psp-config"],
      });
    },
  });
};

export const useConnectPaymentMethod = (payload?: any) => {
  return useSmartMutation(ixIntegrationApi.connectPaymentMethod, {
    ...payload,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["ix", "psp-config"],
      });
    },
  });
};

export const useDecryptPspCredentials = (pspUtilityId: number | null, decrypt: boolean) =>
  useSmartQuery(
    QueryKeyFactory.module.ix.payments.decryptedPspCredentials(pspUtilityId),
    () =>
      ixIntegrationApi.decryptPSPCredentials(pspUtilityId),
    {
      enabled: !!pspUtilityId && !!decrypt,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 10000,
    }
  );